import { motion } from "framer-motion";
import { Plus } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { SectionHead } from "@/components/site/Reveal";
import { FAQS } from "@/data/site";

const schema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: FAQS.map((f) => ({ "@type": "Question", name: f.q, acceptedAnswer: { "@type": "Answer", text: f.a } })),
};

export const Faq = () => (
  <section className="px-6 py-28" data-testid="faq-section">
    <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }} />
    <div className="mx-auto max-w-7xl grid lg:grid-cols-12 gap-14">
      <div className="lg:col-span-5">
        <SectionHead eyebrow="05 / Questions" title={["Good to know", "before you visit."]}
          text="Quick answers about our store in Goregaon East, the brands we carry, GST billing, trade pricing and delivery." />
      </div>
      <motion.div className="lg:col-span-7" initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.1 }} transition={{ duration: 0.9 }}>
        <Accordion type="single" collapsible defaultValue="item-0" className="space-y-3">
          {FAQS.map((f, i) => (
            <AccordionItem key={i} value={`item-${i}`} className="glass rounded-2xl px-6 border-b-0" data-testid={`faq-item-${i}`}>
              <AccordionTrigger className="text-left font-display text-lg hover:no-underline hover:text-[#39FF14] py-5 [&>svg]:hidden group" data-testid={`faq-trigger-${i}`}>
                <span className="pr-6">{f.q}</span>
                <Plus size={18} className="shrink-0 text-[#39FF14] transition-transform duration-300 group-data-[state=open]:rotate-45" />
              </AccordionTrigger>
              <AccordionContent className="text-[#a5b4c8] text-base leading-relaxed pb-6">{f.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </motion.div>
    </div>
  </section>
);
